module.exports = __webpack_public_path__ + "static/03-95583a1a9b12d211992e6109822a9692.jpg";